import { baseApi } from './base'

export interface DataExportResponse {
  fileName: string
  csvContent: string
}

export interface DataExportParams {
  startDate: string
  endDate: string
  establishments?: string
}

export const dataExportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    exportConsultations: builder.query<DataExportResponse, DataExportParams>({
      query: (params) => ({
        url: '/data-export/consultations',
        method: 'GET',
        params,
      }),
    }),

    exportPatients: builder.query<DataExportResponse, DataExportParams>({
      query: (params) => ({
        url: '/data-export/patients',
        method: 'GET',
        params,
      }),
    }),

    exportMedicalActs: builder.query<DataExportResponse, DataExportParams>({
      query: (params) => ({
        url: '/data-export/medical-acts',
        method: 'GET',
        params,
      }),
    }),

    exportMesures: builder.query<DataExportResponse, DataExportParams>({
      query: (params) => ({
        url: '/data-export/mesures',
        method: 'GET',
        params,
      }),
    }),

    exportPregnancies: builder.query<DataExportResponse, DataExportParams>({
      query: (params) => ({
        url: '/data-export/pregnancies',
        method: 'GET',
        params,
      }),
    }),
  }),
  overrideExisting: false,
})
